module.exports = __webpack_public_path__ + "img/dining-room.c5600ed6.jpeg";